import { useState } from 'react';
import { generatePath, useParams } from 'react-router';
import theme from '@/constants/theme';
import { routes } from '@/constants/routes';

import BackButton from '@/components/admin/BackButton';
import CreateEditStageButton from '@/components/admin/stages/CreateEditStageButton';
import DeleteStageButton from '@/components/admin/stages/DeleteStageButton';
import StageContentsTable from '@/components/admin/stages/StageContentsTable';
import ReorderingStageContents from '@/components/admin/stages/ReorderingStageContents';

import useLoadStage from './useLoadStage';
import useLoadStageContents from './useLoadStageContents';

import { styles } from './styles';

const StageDetail = () => {
  const { routeId, stageId } = useParams();

  const { stage } = useLoadStage({ routeId, stageId });
  const { stageContents, handleReload: handleReloadStageContents } = useLoadStageContents({
    routeId,
    stageId,
  });

  const [isOrdering, setIsOrdering] = useState(false);

  if (!routeId || !stageId) return null;

  return (
    <div style={styles.container}>
      <BackButton href={generatePath(routes.admin.routes.detail, { routeId })}>Regresar a la ruta</BackButton>
      <div style={{ display: 'flex', gap: 16, flexDirection: 'column' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
          <h1 style={{ color: theme.colors.text.title }}>{stage?.title ?? 'Ruta no encontrada'}</h1>
          {routeId && (
            <div style={{ display: 'flex', gap: 8 }}>
              <DeleteStageButton routeId={routeId} stageId={stageId} />
              <CreateEditStageButton routeId={routeId} stageId={stageId} />
            </div>
          )}
        </div>
        <p style={{ color: theme.colors.text.body }}>{stage?.description ?? 'No description'}</p>
      </div>
      {isOrdering ? (
        <ReorderingStageContents
          contents={stageContents}
          setIsOrdering={setIsOrdering}
          handleReload={handleReloadStageContents}
        />
      ) : (
        <StageContentsTable
          routeId={routeId}
          stageId={stageId}
          contents={stageContents}
          setIsOrdering={setIsOrdering}
        />
      )}
    </div>
  );
};

export default StageDetail;
